<template>
  <b-button class="shipped-button" v-b-tooltip.hover title="Mark As Shipped">
    <i class="fa fa-truck truck-icon"></i>
  </b-button>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
.truck-icon {
  font-size: 24px !important;
  cursor: pointer;
  transition: all 0.2s;
  color: rgb(28, 187, 140);
}
.shipped-button {
  background-color: inherit;
  border-radius: 10px;
  padding: 10px;
  border: 0px;
  transition: all 0.2s;
  width: 45px;
  height: 45px;
}
.shipped-button:hover .truck-icon {
  transform: scale(1.3);
}
.shipped-button:hover {
  background-color: rgba(28, 187, 140, 0.1);
}
</style>
